module.exports = __webpack_public_path__ + "img/about-cover-2.14bb804f.png";